window.FAFAssets = window.FAFAssets || (() => {
  const pending = new Map();

  const loadScript = (key, source) => {
    if (!key || !source) {
      return Promise.reject(new Error('A script key and source are required.'));
    }

    if (pending.has(key)) return pending.get(key);

    const promise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[data-faf-asset="${CSS.escape(key)}"]`);

      if (existing?.dataset.loaded === 'true') {
        resolve(existing);
        return;
      }

      const script = existing || document.createElement('script');
      script.src = source;
      script.async = true;
      script.dataset.fafAsset = key;
      script.addEventListener('load', () => {
        script.dataset.loaded = 'true';
        resolve(script);
      }, { once: true });
      script.addEventListener('error', () => {
        pending.delete(key);
        if (!existing) script.remove();
        reject(new Error(`${key} could not be loaded.`));
      }, { once: true });

      if (!existing) document.head.appendChild(script);
    });

    pending.set(key, promise);
    return promise;
  };

  return { loadScript };
})();